module.exports = __webpack_public_path__ + "img/38.1abe22d2.jpg";